/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import NewSubscriptionModal from './NewSubscriptionModal.js';
import { connect as ServiceSeverityConnect } from '../ServiceSeverityGrid';
import { connect as SeverityConnect } from '../AllSeverityGrid';

import requestConnector from './requestConnector.js';
import withInstanceList from './withInstanceList.js';

export default ServiceSeverityConnect()(SeverityConnect()(requestConnector(withInstanceList(NewSubscriptionModal))));
